//@flow
import * as Immutable from 'immutable';

import { TaskChecklistValue, TaskPod } from 'common/models/flow/TaskPod';
import type {
    TaskChecklistValueModelType,
    TaskPodModelType
} from 'common/models/flow/TaskPod';

class InternalTaskChecklistValue extends TaskChecklistValue {
    static fromJS(
        json: TaskChecklistValueModelType
    ): InternalTaskChecklistValue {
        const state: Object = Object.assign({}, json);
        state.selectedValues = state.selectedValues
            ? Immutable.List(state.selectedValues)
            : state.selectedValues;
        return new this(Immutable.Map(state));
    }
}

class InternalTaskPod extends TaskPod {
    static fromJS(json: TaskPodModelType): InternalTaskPod {
        const state: Object = Object.assign({}, json);
        state.images = Immutable.List(state.images);
        state.signatures = Immutable.List(state.signatures);
        state.checklistValues = Immutable.List(
            state.checklistValues
        ).map(item => InternalTaskChecklistValue.fromJS(item));
        return new this(Immutable.Map(state));
    }

    get checklistValues(): Immutable.List<TaskChecklistValue> {
        return this._state.get('checklistValues');
    }
}

export {
    InternalTaskChecklistValue as TaskChecklistValue,
    InternalTaskPod as TaskPod
};
